module.exports = __webpack_public_path__ + "img/video_default.e20eabf4.png";